export default "__VITE_ASSET__CDUPz3x___"